module.exports = __webpack_public_path__ + "static/img/AdobeStock_109590142.1f6dc4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/AdobeStock_109590142.jpg
// module id = 1506
// module chunks = 5